import {
  Message
} from 'element-ui'
import {
  setStore,
  getStore
} from '@/util/store'
import {
  validatenull
} from '@/util/validate'
import {
  login,
  getUserInfo,
  logout
} from '@/api/api'

const user = {
  state: {
    userInfo: getStore({
      name: 'userInfo'
    }) || {},
    isLogin: getStore({
      name: 'isLogin'
    }) || 0,
    isChecked: getStore({
      name: 'isChecked'
    }) || false,
    email: getStore({
      name: 'email'
    }) || '',
    noReadMess: getStore({
      name: 'noReadMess'
    }) || 0,
    moduleChooseIndex: getStore({
      name: 'moduleChooseIndex'
    }) || 0,
    fromPath: null // 上一页路由
  },
  actions: {
    // LoginByPhone({commit}, userInfo) {
    //   return new Promise((resolve) => {
    //     login(userInfo.phone, userInfo.code).then(res => {
    //       const data = res.data.data;
    //       console.log(data, 'data')
    //       // commit('SET_TOKEN', data);
    //       // commit('DEL_ALL_TAG');
    //       // commit('CLEAR_LOCK');
    //       resolve();
    //     })
    //   })
    // },

    // //获取用户信息
    // GetUserInfo({commit}) {
    //   return new Promise((resolve, reject) => {
    //     getUserInfo().then((res) => {
    //       const data = res.data.data;
    //       console.log(data, 'getUserInfo')
    //       commit('SET_USER_INFO', data);
    //       resolve(data);
    //     }).catch(err => {
    //       reject(err);
    //     })
    //   })
    // },

    // // 登出
    // LogOut({commit}) {
    //   return new Promise((resolve, reject) => {
    //     logout().then((res) => {
    //       console.log(res, 'LogOut')
    //       // commit('SET_TOKEN', '');
    //       // commit('SET_MENU', []);
    //       // commit('SET_MENU_ALL_NULL', []);
    //       // commit('SET_ROLES', []);
    //       // commit('SET_TAG_LIST', []);
    //       // commit('DEL_ALL_TAG');
    //       // commit('CLEAR_LOCK');
    //       // removeToken();
    //       // removeRefreshToken();
    //       resolve();
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

  },
  mutations: {
    // 存用户信息
    SET_USER_INFO: (state, userInfo) => {
      // console.log(state, userInfo, 'SET_USER_INFO')
      if (validatenull(userInfo.avatar)) {
        userInfo.avatar = "";
        // userInfo.avatar = "/img/bg/img-logo.png";
      }
      state.userInfo = userInfo;
      setStore({
        name: 'userInfo',
        content: state.userInfo
      })
    },

    // 存消息未读数据
    SET_NO_READ_MESS: (state, noReadMess) => {
      // console.log(state, noReadMess, 'SET_NO_READ_MESS')
      state.noReadMess = noReadMess;
      setStore({
        name: 'noReadMess',
        content: state.noReadMess
      })
    },

    // 登录状态
    SET_LOGIN: (state, isLogin) => {
      console.log(state, isLogin, 'SET_LOGIN')
      state.isLogin = isLogin;
      setStore({
        name: 'isLogin',
        content: state.isLogin,
        type: !localStorage.getItem('logonExpire') ? '1' : ''
      })
    },

    // 软件库选择某一模块 在进入了解更多页面时  跳转到对应模块的位置
    SET_MOUDLE_INDEX: (state, moduleChooseIndex) => {
      console.log(state, moduleChooseIndex, 'SET_MOUDLE_INDEX')
      state.moduleChooseIndex = moduleChooseIndex;
      setStore({
        name: 'moduleChooseIndex',
        content: state.moduleChooseIndex
      })
    },
  }

}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js